<ol class="my-breadcrumb">
  <li *ngFor="let breadcrumb of breadcrumbs">
    <span [routerLink]="breadcrumb.url" routerLinkActive="router-link-active" [innerHTML]="translationService.getTranslation('breadcrumb_' + breadcrumb.label)">
    </span>
  </li>
</ol>
